module.exports = __webpack_public_path__ + "static/media/investment.addf9ced.svg";